import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  // HelpCircle,
  LogOut,
  Phone,
  ChevronRight,
  // FileQuestion,
  CreditCard,
  Bookmark
} from "lucide-react";
// import { PaymentMethodsIcon } from "../assets/icons/icons.jsx";
import { dictionary } from "../utils/dictionary";
import ToggleSwitch from "../components/onboarding/ui/ToggleSwitch.js";
import { getCurrency, setCurrency } from "../utils/indexedDBUtils.js";
import { useCallback, useEffect, useState } from "react";
import { SettingsCard } from "../components/cards/SettingCard.js";
// import { validators } from "tailwind-merge";


const SettingsPage = () => {
  const { language } = useAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [currencyLocal, setCurrencyLocal] = useState<boolean>(false);

  const fetchCurrency = async () => {
    const value = await getCurrency();
    setCurrencyLocal(value);
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  const handleCurrencyChange = async () => {
    const value = !currencyLocal;
    setCurrencyLocal(value);
    await setCurrency(value);
    window.dispatchEvent(new Event("currencyChanged"));
  };

  const handleLogout = useCallback(() => {
    logout();
    navigate("/");
  }, [logout, navigate]);

  const settingsOptions = [
    // {
    //   icon: CreditCard,
    //   label: dictionary["payment-methods"][language],
    //   onClick: () => navigate("/payment-methods")
    // },
    {
      icon: CreditCard,
      label: dictionary["integrations"][language],
      onClick: () => navigate("/integrations")
    },
    {
      icon: Bookmark,
      label: dictionary["manage-membership"][language],
      onClick: () => navigate("/membership")
    },
    {
      icon: LogOut,
      label: dictionary["logout"][language],
      rightElement: (
        <button
          onClick={handleLogout}
          className="px-10 py-2 text-[#6A6A6A] border border-gray-400 rounded-lg font-semibold shadow transition-all
            hover:bg-[#F5F6FA] hover:text-[#636DF2]
            group-hover:shadow-lg group-hover:scale-105"
        >
          {dictionary["go-out"][language]}
        </button>
      )
    },
  ];

  return (
    <div className="min-h-screen bg-[#F5F6FA] flex flex-col items-center justify-center font-['Plus_Jakarta_Sans']">
      <Toaster position="top-right" />

      {/* Header aligned to the left */}
      <div className="w-full max-w-lg flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-[#6A6A6A]">{dictionary["settings"][language]}</h1>
        <div className="flex items-center gap-2">
          {/* <span className="text-[#6A6A6A] font-semibold text-sm">{dictionary["currency-cop"][language]}</span>
          <ToggleSwitch
            enabled={currencyLocal}
            onChange={handleCurrencyChange}
          />
          <span className="text-[#6A6A6A] font-semibold text-sm">{dictionary["currency-usd"][language]}</span> */}
        </div>
      </div>

      {settingsOptions.map((option, idx) => (
        <SettingsCard
          key={idx}
          icon={option.icon}
          label={option.label}
          onClick={option.onClick}
          rightElement={option.rightElement}
        />
      ))}

    </div>
  );
};

export default SettingsPage;
